import { ReactNode } from 'react'

import { useSchedulesFeatureGuard } from '@/core/hooks/useSchedulesFeatureGuard'

interface SchedulesFeatureGuardProps {
	children: ReactNode
}

/**
 * Guard component that wraps the entire application and ensures
 * only users with the schedules feature can access it.
 *
 * Users without the feature are redirected to the legacy application
 * (domain without "new." prefix, or localhost:4201 for local development).
 *
 * This guard only activates on new.my.* domains and localhost:4200.
 */
export const SchedulesFeatureGuard: React.FC<SchedulesFeatureGuardProps> = ({
	children,
}) => {
	// Call guard in order to activate the checking based on global state
	useSchedulesFeatureGuard()

	return <>{children}</>
}
